<template>
    <div
        ref="wrapper"
        :class="{ [`l-ss-c-offers-wrapper-${view}`]: true }"
        class="l-ss-c-offers-wrapper"
        @contextmenu="globalHandleMouseDown"
        @mousedown="globalHandleMouseDown"
        @mouseup="globalHandleOfferClick">
        <div
            ref="items"
            class="l-ss-c-offers-wrapper-items"
            @scroll="handleScroll">
            {{ offers }}
            <template v-for="offer in offers">
                <offer
                    :key="`offer-${offer.id}`"
                    :is-cart-available="$configuration.features.addToCartButton"
                    :offer="offer"
                    :style="offerStyle"
                    :templates="templates"
                    class="l-ss-c-offers-item"
                    v-bind="offerProps"
                    @add-to-cart="offer => $emit('add-to-cart', offer)"/>
            </template>
            <slot name="append"></slot>
        </div>
        <template v-if="showArrows">
            <button
                ref="carousel-left"
                class="l-ss-c-results-carousel-button l-ss-c-results-carousel-button-prev"
                style="opacity: 0;"
                @click="slide('left')">
                <i
                    class="l-ss-c-icon"
                    v-html="iconArrowRight"></i>
            </button>
            <button
                ref="carousel-right"
                class="l-ss-c-results-carousel-button l-ss-c-results-carousel-button-next"
                @click="slide('right')">
                <i
                    class="l-ss-c-icon"
                    v-html="iconArrowRight"></i>
            </button>
        </template>
    </div>
</template>

<script>
    import Offer from './offer/offer';
    import IconArrowRight from '../assets/images/icons/arrow-right-results.svg';
    import { AVAILABLE_VIEWS } from '../../init/options/OffersOptions';
    import debounce from '../../core/helpers/debounce';

    const SLIDE_SIZE = 450;
    const SLIDE_DELAY = 75;
    const DEFAULT_GRID_COLUMNS = 4;
    export default {
        components: {
            Offer,
        },
        props: {
            offers: {
                type: Array,
                default: () => [],
            },
            templates: {
                type: Object,
                required: false,
            },
            view: {
                type: String,
                default: 'row',
                validate: (value) => AVAILABLE_VIEWS.includes(value),
            },
            offerProps: {
                type: Object,
                default: () => ({}),
            },
            columns: {
                type: Number,
                default: DEFAULT_GRID_COLUMNS,
            },
        },
        data() {
            return {
                showArrows: false,
                mouseDownInfo: null,
                scrollLeft: 0,
                keepSlideButtonVisible: true,
                handleScroll: () => {},
            };
        },
        computed: {
            iconArrowRight() {
                return this.$configuration.customSvgIconRightArrow ? this.$configuration.customSvgIconRightArrow : IconArrowRight;
            },
            offerStyle() {
                const style = {};
                if (this.view === 'grid') {
                    style['--offer-item-width'] = `${100 / this.columns}%`;
                }
                return style;
            },
        },
        watch: {
            offers: {
                handler() {
                    this.handleArrows();
                },
            },
        },
        mounted() {
            this.handleArrows();
            this.handleScroll = debounce(this.handleScrollUser.bind(this), SLIDE_DELAY);
        },
        methods: {
            slide(direction = 'right') {
                this.keepSlideButtonVisible = true;
                const itemsWrapper = this.$refs['items'];
                const leftButton = this.$refs['carousel-left'];
                const rightButton = this.$refs['carousel-right'];
                const maxScrollLeft = itemsWrapper.scrollWidth - itemsWrapper.clientWidth;
                const scrollLeft = direction === 'right' ?
                    itemsWrapper.scrollLeft + SLIDE_SIZE :
                    itemsWrapper.scrollLeft - SLIDE_SIZE;
                itemsWrapper.scroll({
                    left: scrollLeft,
                    behavior: 'smooth',
                });
                if (direction === 'right') {
                    if (leftButton) leftButton.style.opacity = '1';
                    if (rightButton) rightButton.style.opacity = scrollLeft <= maxScrollLeft ? '1' : '0';
                } else {
                    if (rightButton) rightButton.style.opacity = '1';
                    if (leftButton) leftButton.style.opacity = scrollLeft > 0 ? '1' : '0';
                }
                this.scrollLeft = scrollLeft;
            },
            getOfferPosition(index, options = {}) {
                const OFFERS_PER_ROW_MOBILE = 2;
                const OFFERS_PER_ROW_CUT = this.columns - 1;
                const OFFERS_PER_ROW_DEFAULT = options.groupIndex !== undefined ? OFFERS_PER_ROW_CUT : this.columns;
                const ADAPTIVE_OFFERS_PER_ROW = this.$screen.isMobile ? OFFERS_PER_ROW_MOBILE : OFFERS_PER_ROW_DEFAULT;
                let pos = index + 1;
                let row = Math.floor(index / ADAPTIVE_OFFERS_PER_ROW) + 1;
                let page = isNaN(parseInt(options.page)) ? 1 : parseInt(options.page) || 1;
                return {
                    pos: (options.startIndex ? index + options.startIndex + 1 : pos) * page,
                    row: options.row ? parseInt(options.row) : row,
                    col: this.view === 'row' ? index + 1 : ADAPTIVE_OFFERS_PER_ROW -
                        ((row * ADAPTIVE_OFFERS_PER_ROW) - pos) +
                        (ADAPTIVE_OFFERS_PER_ROW < OFFERS_PER_ROW_DEFAULT ? (options.groupIndex || 0) : 0),
                };
            },
            handleScrollUser() {
                if (this.keepSlideButtonVisible) {
                    this.keepSlideButtonVisible = false;
                    return;
                }
                const itemsWrapper = this.$refs['items'];
                const leftButton = this.$refs['carousel-left'];
                const rightButton = this.$refs['carousel-right'];
                if (this.scrollLeft > itemsWrapper.scrollLeft) {
                    if (leftButton) leftButton.style.opacity = '0';
                    if (rightButton) rightButton.style.opacity = '1';
                } else {
                    if (leftButton) leftButton.style.opacity = '1';
                    if (rightButton) rightButton.style.opacity = '0';
                }
                this.scrollLeft = itemsWrapper.scrollLeft;
            },
            globalHandleOfferClick(event, positionOptions = {}) {
                const path = event.path || (event.composedPath && event.composedPath());
                const offerTarget = path.find(element => element.dataset && element.dataset.offerId);
                if (offerTarget && this.mouseDownInfo) {
                    const sameLocation =
                        this.mouseDownInfo.pageX === event.pageX &&
                        this.mouseDownInfo.pageY === event.pageY;
                    if (Boolean(this.mouseDownInfo) === false || sameLocation === false) {
                        return;
                    }
                    const offerId = offerTarget.dataset.offerId;
                    const offer = this.offers.find(item => item.id === offerId);
                    const positionIndex = Array.prototype.indexOf.call(offerTarget.parentNode.children, offerTarget);
                    this.$emit('offer-click', Object.assign({
                        event: event,
                        id: offer.id,
                        url: offer.url,
                    }, this.getOfferPosition(positionIndex, Object.assign(positionOptions, {
                        groupIndex: offerTarget.dataset.groupIndex,
                        offersInRow: offerTarget.dataset.offersInRow,
                        page: offerTarget.dataset.page,
                        row: offerTarget.dataset.row,
                    }))));
                }
                this.mouseDownInfo = null;
            },
            globalHandleMouseDown(event) {
                this.mouseDownInfo = {
                    pageX: event.pageX,
                    pageY: event.pageY,
                };
            },
            handleArrows() {
                this.$nextTick(() => {
                    if (this.view === 'row' && this.$refs.wrapper && this.$refs.items) {
                        this.showArrows = this.$refs.items.scrollWidth > this.$refs.wrapper.offsetWidth;
                    }
                });
            },
        },
    };
</script>
